import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Indicators Components
import { IndicadoresComponent } from './shared/indicadores.component';
import { IndicatorsFuelComponent } from './indicators-fuel/indicators-fuel.component';
import { IndicatorsMaintenanceComponent } from './indicators-maintenance/indicators-maintenance.component';
import { IndicatorsInventoryComponent } from './indicators-inventory/indicators-inventory.component';

const IndicatorsComponents = [
  IndicadoresComponent,
  IndicatorsFuelComponent,
  IndicatorsMaintenanceComponent,
  IndicatorsInventoryComponent
];

@NgModule({
  declarations: IndicatorsComponents,
  imports: [SharedModule],
  exports: IndicatorsComponents
})
export class IndicatorsModule { }
